var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { legendPreviewAlarmSystemAlarmDevicesPath } from '../../../routes';
export function getDeviceLegend(alarmSystemId) {
    return __awaiter(this, void 0, void 0, function* () {
        // js-routes: pass the id in an options object, not positionally. A bare positional
        // arg binds to the optional `(:locale)` scope, yielding `/:id/alarm_systems/:id/...`.
        // `_options: true` marks the object as options rather than a model to serialize.
        const path = legendPreviewAlarmSystemAlarmDevicesPath({
            alarm_system_id: alarmSystemId,
            format: 'json',
            _options: true
        });
        const { data } = yield api.get(path);
        return data;
    });
}
